import { FoodTypesDto } from "@gtpl/shared-models/masters";
import { RmLevel } from "../rm-level-entity";
import { RmLevelDTO } from "./rm-level.dto";


export class RmLevelAdapter {
    convertDtoToEntity(dtoObj: RmLevelDTO,  isUpdate: boolean = false ): RmLevel {
        try {
            const entityObj = new RmLevel();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.levelCode = dtoObj.levelCode;
            entityObj.levelName = dtoObj.levelName;
            if (dtoObj.levelId) {
                entityObj.levelId = dtoObj.levelId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;
            return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(levelObject: RmLevel): RmLevelDTO {
        const levelDTO= new RmLevelDTO;
        levelDTO.levelId = levelObject.levelId;
        levelDTO.levelCode = levelObject.levelCode;
        levelDTO.levelName = levelObject.levelName;
        levelDTO.isActive = levelObject.isActive;
        levelDTO.createdAt = levelObject.createdAt;
        levelDTO.updatedAt = levelObject.updatedAt;
        levelDTO.createdUser = levelObject.createdUser;
        levelDTO.updatedUser = levelObject.updatedUser;
        levelDTO.versionFlag = levelObject.versionFlag;
        return levelDTO;
      }
}